export default "__VITE_ASSET__9QrlxAFj__"